import { LABELS } from '../../constants';
import {
  extractPostingSublocationBuckets,
  resolvePostedBy,
  resolvePostedOn,
  resolvePostedWeek,
  resolvePostingDate,
  resolveProductType,
  toTrimmedString,
} from '../../utils/glPostingMethods';

export const buildApprovedPostingData = ({ isApprovedPosting, rowState, postingDetails, normalizedPostingId }) => {
  if (!isApprovedPosting) return null;

  const postingSource = postingDetails || {};

  const postingId =
    rowState?.postingId || postingSource?.postingId || postingSource?.id || normalizedPostingId || LABELS.NOT_AVAILABLE;
  const createdByUserFirstName = toTrimmedString(postingSource?.createdByUser?.firstName);
  const createdByUserLastName = toTrimmedString(postingSource?.createdByUser?.lastName);
  const createdByUserFullName = [createdByUserFirstName, createdByUserLastName].filter(Boolean).join(' ').trim();
  const rowStateCreatedBy =
    rowState?.createdBy !== null && rowState?.createdBy !== undefined ? String(rowState.createdBy).trim() : '';
  const createdBy =
    createdByUserFullName || resolvePostedBy(postingSource) || rowStateCreatedBy || LABELS.NOT_AVAILABLE;
  const postedWeek = rowState?.postedWeek || resolvePostedWeek(postingSource) || LABELS.NOT_AVAILABLE;
  const postingDate = rowState?.postingDate || resolvePostingDate(postingSource) || LABELS.NOT_AVAILABLE;
  const productType = rowState?.productType || resolveProductType(postingSource) || LABELS.NOT_AVAILABLE;
  const x3ProductName = toTrimmedString(
    rowState?.x3ProductName ||
      postingSource?.x3ProductName ||
      postingSource?.x3_product_name ||
      postingSource?.productCategory?.x3_productname ||
      postingSource?.product?.x3_productname ||
      '',
  ).toUpperCase();
  const postedOn = resolvePostedOn(postingSource) || LABELS.NOT_AVAILABLE;

  const postingBuckets = extractPostingSublocationBuckets(postingSource);
  const rowBuckets = extractPostingSublocationBuckets(rowState || {});
  const postingBucketSize = postingBuckets.selectedSublocations.length + postingBuckets.unselectedSublocations.length;
  const rowBucketSize = rowBuckets.selectedSublocations.length + rowBuckets.unselectedSublocations.length;
  const effectiveBuckets = rowBucketSize > postingBucketSize ? rowBuckets : postingBuckets;
  const { selectedSublocations, unselectedSublocations } = effectiveBuckets;

  return {
    postingId,
    createdBy,
    postedWeek,
    postingDate,
    productType,
    x3ProductName: x3ProductName || toTrimmedString(productType).toUpperCase(),
    postedOn,
    selectedSublocations,
    unselectedSublocations,
  };
};
